import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="hero-section" ></div>

      <div className="responsive-images">
        <img 
          src="homephon1.jpg" 
          alt="Image 1" 
          className="responsive-image"
        />
        <img 
          src="homephon2.jpg" 
          alt="Image 2" 
          className="responsive-image"
        />
      </div>

      <div className="content">
        <h1>אז מה בעצם אנחנו מציעים?</h1>
     {/* Cards Section */}
     <div className="features">
        <div className="card">
          <h3>מעקב קל ונח אחרי כמות מוזמנים</h3>
          <p>ניהול מספר המוזמנים בצורה מסודרת ויעילה.</p>
        </div>
        <div className="card">
          <h3>שליחת הזמנות אוטומטית</h3>
          <p>חיסכון בזמן עם הזמנות דיגיטליות מהירות.</p>
        </div>
        <div className="card">
          <h3>אישורי הגעה דרך ווצאפ</h3>
          <p>אישורי הגעה חכמים באמצעות ווצאפ.</p>
        </div>
        <div className="card">
          <h3>סידור שולחנות ומקומות ישיבה</h3>
          <p>סידור שולחנות בהתאמה אישית לאירוע שלכם.</p>
        </div>
        <div className="card">
          <h3>ליווי לאורך כל הדרך</h3>
          <p>ליווי מקצועי עד ליום האירוע עצמו.</p>
        </div>
        </div>
      </div>

      <footer className="footer">
        <p>מריאז' - כאן כדי להפוך את היום שלכם למושלם | © 2024</p>
      </footer>
    </div>
  );
};

export default Home;
